module.exports = __webpack_public_path__ + "img/dev-default.8c770d81.png";